import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const ENTITY_REQUEST_FORMS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('ENTITY_REQUEST_FORMS');
export const ENTITY_REQUEST_FORMS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	ENTITY_REQUEST_FORMS_CRUD_ACTION_CONSTANTS
);
